// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","453":"54292a4b","455":"fe4744a1","762":"5bd01cd1","977":"b584b783"}[chunkId] + ".chunk.js";
};